/* eslint-disable tss-unused-classes/unused-classes */
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const reimbursementModStyles = makeStyles<{ isExpanded?: boolean }>()((theme: Theme, { isExpanded }) => ({
  gridRow: {
    marginTop: '24px',
    width: isExpanded ? '350px' : '249px',
  },
  smallGridRow: {
    marginTop: '15px',
    width: isExpanded ? '350px' : '249px',
  },
  inputFields: {
    width: isExpanded ? '350px !important' : '249px',
    minWidth: isExpanded ? '350px !important' : '249px',
    '& .MuiInputLabel-root-inputFields.Mui-disabled': {
      color: '#333333 !important',
    },
  },
  dollarTextfields: {
    width: isExpanded ? '350px !important' : '249px',
    fontSize: '14px',
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      marginRight: '0px',
    },
  },
  providerLb: {
    fontSize: '12px !important',
    fontWeight: 'bold',
    marginRight: '24px',
  },

  radioLabel: {    
    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: '#333333',
    },
  },
}));
